module.exports = __webpack_public_path__ + "c4d82460ef260eb1589e73528cbfb257.eot";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/OpenSans-Regular-webfont.eot
// module id = 444
// module chunks = 0